<template>
  <div class="animated revealUp">
    <div class="white-wrapper">
      <div class="section-title mb-4">
        Distributor Detailed Report Play Cinema
      </div>

      <div class="mt-3 border-bottom">
        <div class="row">
          <div class="col-lg-6 col-xl-3 mb-4">
            <div class="input-material">
              <div class="add-datepicker">
                <Datepicker
                  ref="programaticOpen"
                  v-model="fromDate"
                  v-validate="'required'"
                  :monday-first="true"
                  typeable
                  @selected="onchangeDate($event, 'from')"
                ></Datepicker>
                <label :class="fromDate ? 'active' : ''">Show From Date</label>
              </div>
            </div>
          </div>

          <div class="col-lg-6 col-xl-3 mb-4">
            <div class="input-material">
              <div class="add-datepicker">
                <Datepicker
                  ref="programaticOpen"
                  v-model="toDate"
                  v-validate="'required'"
                  :monday-first="true"
                  typeable
                  @selected="onchangeDate($event, 'from')"
                ></Datepicker>
                <!-- disabled -->
                <label :class="toDate ? 'active' : ''">Show To Date</label>
              </div>
            </div>
          </div>

          <div class="col-lg-6 col-xl-3 mb-4">
            <div class="d-flex align-items-center">
              <div class="dropdown-curve-container">
                <label :class="selectedCinema ? 'shift-up' : ''">
                  {{ "Select Cinema" }}
                </label>

                <multiselect
                  id="cine_id"
                  v-model="selectedCinema"
                  :multiple="false"
                  :options="Cinemas"
                  deselect-label="Remove"
                  label="cine_name"
                  name="cine_id"
                  placeholder=""
                  select-label="Select"
                  track-by="cine_id"
                  @remove="onRemoveHandler($event, 'cinema')"
                  @select="onSelectHandler($event, 'cinema')"
                >
                </multiselect>
              </div>
            </div>
          </div>

          <div class="col-lg-6 col-xl-3 mb-4">
            <div class="d-flex align-items-center">
              <div class="dropdown-curve-container">
                <label
                  :class="selectedDistributor.length > 0 ? 'shift-up' : ''"
                >
                  {{ "Distributor" }}
                </label>

                <multiselect
                  id="d_id"
                  v-model="selectedDistributor"
                  :multiple="true"
                  :options="getDistributorReportDropdownList"
                  deselect-label="Remove"
                  label="d_company_name"
                  name="d_id"
                  placeholder=""
                  select-label="Select"
                  track-by="d_id"
                  @input="onSelectHandler($event, 'distributor')"
                  @remove="onRemoveHandler($event, 'distributor')"
                >
                </multiselect>
              </div>
            </div>
          </div>

          <div class="col-lg-6 col-xl-3 mb-4">
            <div class="d-flex align-items-center">
              <div class="dropdown-curve-container">
                <label :class="selectedMovie.length > 0 ? 'shift-up' : ''">
                  {{ "Movie" }}
                </label>

                <multiselect
                  id="movie_id"
                  v-model="selectedMovie"
                  :multiple="true"
                  :options="MovieList"
                  deselect-label="Remove"
                  label="movie_title"
                  name="movie_id"
                  placeholder=""
                  select-label="Select"
                  track-by="movie_id"
                  @remove="onRemoveHandler($event, 'movie')"
                  @select="onSelectHandler($event, 'movie')"
                >
                </multiselect>
              </div>
            </div>
          </div>

          <div class="col-lg-6 col-xl-3 align-self-center mb-3">
            <button
              class="btn-blue-lg w-100"
              @click.prevent.stop="fDistributorReportList"
            >
              {{ $tc("Fetch Report") }}
            </button>
          </div>

          <!--  -->
          <div
            v-if="DistributorCollection.length > 0"
            class="d-flex justify-content-end align-items-center col-lg-6 col-xl-3 align-self-center mb-3"
          >
            <div class="mr-2">Download as:</div>
            <a
              v-if="PDFName"
              :href="BASE_URL + PDFName"
              download
              target="_blank"
              title="Download as PDF"
            >
              <img
                height="25"
                src="@/assets/img/icons/pdf-icon.svg"
                width="25"
              />
            </a>

            <a
              v-if="ExcelName"
              :href="BASE_URL + ExcelName"
              download
              target="_blank"
              title="Download as Excel"
            >
              <img height="25" src="@/assets/img/icons/excel.svg" width="25" />
            </a>
          </div>
        </div>
      </div>
      <div v-if="DistributorCollection.length == 0" class="swc-report">
        <table border="1" class="swc-report-table">
          <thead>
            <tr>
              <th class="text-left">Cinema</th>
              <th class="text-left">Distributor</th>
              <th class="text-left">Movie Name</th>
              <th class="text-left">Show Date</th>
              <th>Show Time</th>
              <th>Screen</th>
              <th>Type</th>
              <th v-if="debug">Seat-Ticket Type</th>
              <th v-if="debug">Rate Card</th>
              <th v-if="debug">RATE</th>
              <th>Admits</th>
              <th v-if="showComp">Compl Admits</th>
              <th>Gross</th>
              <th>Net</th>
              <th>Distributor Share</th>
              <!-- <th>VAT</th> -->
            </tr>
          </thead>
          <tbody>
            <tr>
              <td colspan="16">
                <div class="h6 my-3 text-center">{{ $t("NoRecords") }}</div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <div
        v-if="DistributorCollection.length > 0"
        class="swc-report table-scroll"
      >
        <table border="1" class="swc-report-table">
          <thead>
            <tr>
              <th class="text-left">Cinema</th>
              <th class="text-left">Distributor</th>
              <th class="text-left">Movie Name</th>
              <th class="text-left">Show Date</th>
              <th>Show Time</th>
              <th>Screen</th>
              <th>Type</th>
              <th v-if="debug">Seat-Ticket Type</th>
              <th v-if="debug">Rate Card</th>
              <th v-if="debug">RATE</th>
              <th>Admits</th>
              <th v-if="showComp">Compl Admits</th>
              <th>Gross</th>
              <th>Net</th>
              <th>Distributor Share</th>
              <!-- <th>VAT</th> -->
            </tr>
          </thead>

          <tbody>
            <template
              v-for="(item, itemIndex) in DistributorCollection"
              class="mb-5"
            >
              <template v-for="disMovie in item">
                <tr v-for="(show, showIndex) in disMovie.Data" :key="showIndex">
                  <td
                    v-if="showIndex == 0"
                    :rowSpan="disMovie.Data.length"
                    class="text-left"
                  >
                    {{ show.cine_name }}
                  </td>
                  <td
                    v-if="showIndex == 0"
                    :rowSpan="disMovie.Data.length"
                    class="text-left"
                  >
                    {{ show.dist_company_name }}
                  </td>
                  <td
                    v-if="showIndex == 0"
                    :rowSpan="disMovie.Data.length"
                    class="text-left"
                  >
                    {{ show.movie_name }}
                  </td>
                  <td class="text-left">
                    {{
                      show.display_date
                        ? moment(show.display_date, "DD-MM-YYYY").format(
                            "DD-MMM-YYYY"
                          )
                        : show.show_date
                    }}
                  </td>
                  <td>
                    {{ moment(show.t_show_time, "HH:mm").format("hh:mm a") }}
                  </td>
                  <td>{{ show.screen_name }}</td>
                  <td>{{ show.display_type }}</td>
                  <td v-if="debug">{{ show.st_name }} - {{ show.tt_name }}</td>
                  <td v-if="debug">
                    {{ show.rc_g_name }} - {{ show.rc_name }}
                  </td>
                  <td v-if="debug">
                    {{ show.reporting_rc_amount }} | {{ show.rate }} |
                    {{ show.dist_share_threshold }} |
                    {{ show.off_name || "-" }}
                  </td>
                  <td>{{ show.total_tickets }}</td>
                  <td v-if="showComp">{{ show.compl_count_v2 }}</td>
                  <td>{{ currFormat(show["new_actual_gross"]) }}</td>
                  <td>{{ currFormat(show["new_actual_net"]) }}</td>
                  <td>{{ currFormat(show["new_net"]) }}</td>
                  <!-- <td>{{ currFormat(show["txct_vat"]) }}</td> -->
                </tr>
              </template>
              <tr :key="itemIndex" class="color-blue">
                <th colspan="2">Final Total</th>
                <th colspan="1">
                  No. of Shows =
                  {{
                    item[0] && item[0].Data && item[0].Data[0]
                      ? item[0].Data[0].md_ss_id_count
                      : 0
                  }}
                </th>
                <th :colspan="debug ? 7 : 4"> </th>
                <th>
                  {{
                    item.reduce((a, b) => {
                      b.Data.forEach(c => {
                        a += c.total_tickets || 0;
                      });
                      return a;
                    }, 0)
                  }}
                </th>
                <th v-if="showComp">
                  {{
                    item.reduce((a, b) => {
                      b.Data.forEach(c => {
                        a += c.compl_count_v2 || 0;
                      });
                      return a;
                    }, 0)
                  }}
                </th>
                <th>
                  {{
                    currFormat(
                      item.reduce((a, b) => {
                        b.Data.forEach(c => {
                          a += c.new_actual_gross || 0;
                        });
                        return a;
                      }, 0)
                    )
                  }}
                </th>
                <th>
                  {{
                    currFormat(
                      item.reduce((a, b) => {
                        b.Data.forEach(c => {
                          a += c.new_actual_net || 0;
                        });
                        return a;
                      }, 0)
                    )
                  }}
                </th>
                <th>
                  {{
                    currFormat(
                      item.reduce((a, b) => {
                        b.Data.forEach(c => {
                          a += c.new_net || 0;
                        });
                        return a;
                      }, 0)
                    )
                  }}
                </th>
                <!-- <th class="_net2">
                  {{
                    currFormat(
                      item.reduce((a, b) => {
                        b.Data.forEach((c) => {
                          a += c.total_tax || 0;
                        });
                        return a;
                      }, 0)
                    )
                  }}
                </th> -->
              </tr>
              <tr :key="itemIndex" style="height: 40px"></tr>
            </template>
          </tbody>
        </table>
      </div>

      <hr class="my-2" />

      <div class="swc-report row" v-if="false">
        <div class="col-md-4" v-if="isToday && selectedMovie.length == 1">
          <h6 class="font-weight-bold text-center">TODAY</h6>
          <table border="1" class="swc-report-table">
            <thead>
              <tr style="background: lightgrey;">
                <td class="font-weight-bold">
                  Show
                </td>
                <td class="font-weight-bold">
                  Aud
                </td>
                <td class="font-weight-bold">
                  Net
                </td>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(show, showIndex) in TodaysData" :key="showIndex">
                <td class="text-right">
                  {{ moment(show.t_show_time, "HH:mm").format("hh:mm a") }}
                </td>

                <td class="text-right">{{ show.totalTicket }}</td>

                <td class="text-right">
                  {{ currFormat(show["totalNetAmount"]) }}
                </td>
              </tr>

              <tr class="color-blue">
                <th>Total</th>

                <th class="text-right">
                  {{
                    TodaystotalAdmints.reduce((a, b) => {
                      return a + b;
                    }, 0)
                  }}
                </th>
                <th class="text-right">
                  {{
                    TodaystotalNetAmount.reduce((a, b) => {
                      return a + b;
                    }, 0).toFixed(3)
                  }}
                </th>
              </tr>
            </tbody>
          </table>
        </div>

        <div class="col-md-4" v-if="isToday && selectedMovie.length == 1">
          <h6 class="font-weight-bold text-center">This Week</h6>
          <table border="1" class="swc-report-table">
            <thead>
              <tr style="background: lightgrey;">
                <td class="font-weight-bold">
                  Day
                </td>
                <td class="font-weight-bold">
                  Show
                </td>
                <td class="font-weight-bold">
                  Aud
                </td>
                <td class="font-weight-bold">
                  Nett
                </td>
              </tr>
            </thead>
            <tbody>
              <tr
                v-for="(show, showIndexNew) in epixWeekwisedata"
                :key="showIndexNew"
              >
                <td class="text-right">
                  {{
                    show.ss_start_date
                      ? moment(show.ss_start_date, "YYYY-MM-DD").format("dddd")
                      : show.ss_start_date
                  }}
                </td>

                <td class="text-right">
                  {{ show.show_count ? show.show_count : 0 }}
                </td>

                <td class="text-right">
                  {{
                    // currFormat(show["totalNetAmount"])
                    show.seats_count ? show.seats_count : 0
                  }}
                </td>

                <td class="text-right">
                  {{
                    // currFormat(show["totalNetAmount"])
                    show.net_amount ? show.net_amount.toFixed(3) : 0
                  }}
                </td>
              </tr>

              <tr class="color-blue">
                <th>Total</th>

                <th class="text-right">
                  {{ weekTotalShow }}
                  <!-- {{
                    weekTotalShow.reduce((a, b) => {
                      return a + b;
                    }, 0)
                  }} -->
                </th>
                <th class="text-right">
                  {{ weekTotalTicket }}
                  <!-- {{
                    weekTotalTicket
                      .reduce((a, b) => {
                        return a + b;
                      }, 0)
                      .toFixed(3)
                  }} -->
                </th>
                <th class="text-right">
                  {{ weekTotalNet }}
                  <!-- {{
                    weekTotalTicket
                      .reduce((a, b) => {
                        return a + b;
                      }, 0)
                      .toFixed(3)
                  }} -->
                </th>
              </tr>
            </tbody>
          </table>
        </div>
        <template v-if="false">
          <div class="col-md-4" v-if="isToday && selectedMovie.length == 1">
            <h6 class="font-weight-bold text-center">THIS RUN (ALL SCREEN)</h6>
            <table border="1" class="swc-report-table">
              <thead>
                <tr style="background: lightgrey;">
                  <td class="font-weight-bold">
                    Aud
                  </td>
                  <td class="font-weight-bold">
                    Net
                  </td>
                </tr>
              </thead>
              <tbody>
                <!-- <template
                v-for="(item, itemIndex) in DistributorCollection"
                class="mb-5"
              >
                <template v-for="disMovie in item">
                  <tr
                    v-for="(show, showIndex) in disMovie.Data"
                    :key="showIndex"
                  >
                    <td class="text-right">{{ show.total_tickets }}</td>

                    <td class="text-right">{{
                      currFormat(show["new_net"])
                    }}</td>
                  </tr>
                </template>
              </template> -->
                <tr class="color-blue">
                  <th class="text-right">
                    <!-- {{ AlltotalAdmints }} -->
                    {{
                      movieRunSales.length ? movieRunSales[0]["seats_count"] : 0
                    }}
                  </th>
                  <th class="text-right">
                    <!-- {{ AlltotalNetAmount }} -->
                    {{
                      movieRunSales.length
                        ? currFormat(movieRunSales[0]["net_amount"])
                        : 0
                    }}
                  </th>
                </tr>
              </tbody>
            </table>
          </div>
        </template>
      </div>
    </div>
  </div>
</template>
<script>
import { CLIENT_NAME } from "@/helper/Role";
import { mapActions, mapGetters } from "vuex";
import moment from "moment";
import MasterService from "@/services/MasterService";
import ReportsService from "@/services/ReportsService";
import { authenticationService } from "@/services/AuthenticationService";
import xlsx from "json-as-xlsx";

export default {
  data() {
    return {
      showComp: true,
      TodaysData: [],
      isToday: false,
      oneMovielength: false,
      debug: false,
      CLIENT_NAME,
      FilePathArray: [],
      MovieList: [],
      PDFName: "",
      ExcelName: "",
      DistributorCollection: [],
      epixWeekwisedata: [],
      weekTotalTicket: 0,
      weekTotalShow: 0,
      weekTotalNet: 0,
      TodaystotalAdmints: [],
      TodaystotalNetAmount: [],
      AlltotalAdmints: 0.0,
      AlltotalNetAmount: 0.0,
      FinalTotalCharges: [],
      movieRunSales: [],
      Cinemas: [],
      selectedCinema: "",
      cinema_id: null,
      selectedDistributor: [],
      d_id: null,
      selectedMovie: [],
      movie_id: null,
      fromDate: new Date(),
      toDate: new Date(),
      CinemasCopy: [],
      searchCinema: ""
    };
  },
  computed: {
    ...mapGetters([
      // GET LIST ONLY FROM MASTER STORE
      "getCinemasList",

      // Selected Dropdowns
      "getDistributorReportSelectedMovie",
      "getDistributorReportSelectedCinema",
      "getDistributorReportSelectedDistributor",
      // Flags
      "getDistributorReportsIsCinema",
      "getDistributorReportsIsDistributor",
      // Selected Dates
      "getDistributorReportToDate",
      "getDistributorReportFromDate",
      // Get List
      "getDistributorReportList",
      "getDistributorReportDropdownList",
      "getDistributorReportMoviesList",
      "getDistributorReportChargeList",
      "getdistributorReportsListV2",
      // GET EXCEL FILE
      "getDistributorExcelFileName",
      // PDF
      "getDistributorPDFFileName",

      // GET WEEK DATA
      "getDateWeekData",
      //
      "getReleaseDate",
      "getWeekStartDay",

      "getDistributorReportSelectedMovieId",
      "getDistributorReportSelectedDistributorId",
      "getDistributorReportSelectedCinemaId",
      "getIfNoDataInDateRange"
    ]),
    distributorIds() {
      let text = ``;
      if (this.selectedDistributor.length > 0) {
        text = this.selectedDistributor.map(x => x.d_id).join(",");
      }

      return text;
    },
    movieIds() {
      let text = ``;
      if (this.selectedMovie.length > 0) {
        text = this.selectedMovie.map(x => x.md_id).join(",");
      }

      return text;
    }
  },
  beforeMount() {
    this.debug = !!this.$route.query.debug;

    let cinemaId =
      this.secureStore.get("USINFO") &&
      this.secureStore.get("USINFO")["cinema_id"]
        ? this.secureStore.get("USINFO").cinema_id
        : null;

    this.getCinemaList(cinemaId);

    let CinemaObj = this.$store.getters.getSelectedDropDownCinema;
    if (CinemaObj) {
      this.onSelectHandler(CinemaObj, "cinema");
    }

    this.fetchCinemasList({ cinemaId });
    this.fetchReportDistributorsList();
  },
  created() {
    window.addEventListener("unload", event => {
      this.removeDownloadedFile();
    });
  },
  beforeDestroy() {
    this.removeDownloadedFile();
  },
  mounted() {},
  methods: {
    moment,
    onchangeDate(e, type) {
      if (type == "from") {
        this.toDate = new Date(e);
        this.$forceUpdate();
      }

      this.selectedDistributor = [];
      this.selectedMovie = [];
      this.$forceUpdate();
    },
    fetchDistributorMovies() {
      if (!this.cinema_id) {
        this.$toasted.show("Please Select Cinema");
        this.selectedDistributor = [];
        this.$forceUpdate();
      } else {
        this.MovieList = [];
        let payload = {
          fromDate: this.fromDate,
          toDate: this.toDate,
          cinema_id: this.cinema_id,
          cinema_name: this.selectedCinema.cine_name,
          d_id: this.distributorIds,
          d_company_name: this.selectedDistributor
            .map(x => x.d_company_name)
            .join(","),
          country_id: authenticationService.get("BRGLOPCO"),
          filter_with_key: "ss_actual_start_date"
        };
        ReportsService.GetDistributorMovieFormat(payload)
          .then(response => {
            const { data } = response;
            if (data && data.status && data.Records) {
              this.MovieList = data.Records;
            } else
              this.$toasted.show(data.message || "Opps! Something went wrong");
          })
          .catch(error => {
            this.$toasted.show(
              "Catch Error on ReportStore fetchDistributorMovies",
              error
            );
          });
      }
    },
    fDistributorReportList: async function() {
      this.DistributorCollection = [];
      this.epixWeekwisedata = [];
      let fromDate = moment(new Date(this.fromDate)).format("YYYY-MM-DD");
      let toDate = moment(new Date(this.toDate)).format("YYYY-MM-DD");

      console.log("fromDate", fromDate);
      console.log("toDate", toDate);

      if (new Date(fromDate) > new Date(toDate)) {
        this.$toasted.show("From date should not be greater than To date.");
      } else if (!this.cinema_id) {
        this.$toasted.show("Please Select any Cinema.");
      } else {
        let loader = this.$loading.show();
        this.oneMovielength = this.selectedMovie.length == 1 ? true : false;
        if (fromDate == toDate) {
          this.isToday = true;
        } else {
          this.isToday = false;
        }
        let payload = {
          fromDate: fromDate,
          toDate: toDate,
          cinema_id: this.cinema_id,
          cinema_name: this.selectedCinema.cine_name,
          cinema_address: this.selectedCinema.cine_address,
          d_id: this.distributorIds,
          d_company_name: this.selectedDistributor
            .map(x => x.d_company_name)
            .join(","),
          movie_id: this.movieIds,
          movie_title: this.selectedMovie.map(x => x.movie_title).join(","),
          noDataInDateRange: false,
          weekWithNoSchedule: false,
          filter_with_key: "ss_actual_start_date",
          isComplementary: "N",
          oneMovielength: this.oneMovielength,
          isToday: this.isToday
        };
        console.log("payload", { ...payload });

        ReportsService.GetDistributorDetailedSummaryReportPlayCinema(payload)
          .then(async response => {
            const { data } = response;

            if (data && data.status && data.data) {
              this.epixWeekwisedata = data.finalWeekArray;
              this.DistributorCollection = data.data;
              this.TodaysData = data.TodaysData;
              this.TodaystotalAdmints = [];
              this.TodaystotalNetAmount = [];
              this.movieRunSales = data.finalMovieRunSales || [];

              this.TodaystotalNetAmount = this.TodaysData.map(x => {
                return x.totalNetAmount;
              });
              this.TodaystotalAdmints = this.TodaysData.map(x => {
                return x.totalTicket;
              });

              let AlltotalAdmints = [];
              this.DistributorCollection.map(elem => {
                return elem.map(t => {
                  return t.Data.map(x => {
                    return AlltotalAdmints.push(x.total_tickets);
                  });
                });
              });

              this.AlltotalAdmints = AlltotalAdmints.reduce((acc, curr) => {
                return acc + curr;
              }, 0);

              let AlltotalNetAmount = [];
              this.DistributorCollection.map(elem => {
                return elem.map(t => {
                  return t.Data.map(x => {
                    return AlltotalNetAmount.push(x.new_net);
                  });
                });
              });

              this.AlltotalNetAmount = AlltotalNetAmount.reduce((acc, curr) => {
                return acc + curr;
              }, 0).toFixed(3);

              let weekTotalTicket = [];
              weekTotalTicket = this.epixWeekwisedata.reduce((acc, curr) => {
                return acc + curr.seats_count;
              }, 0);
              this.weekTotalTicket = weekTotalTicket;

              let weekTotalShow = [];
              weekTotalShow = this.epixWeekwisedata.reduce((acc, curr) => {
                return acc + curr.show_count;
              }, 0);
              this.weekTotalShow = weekTotalShow;

              let weekTotalNet = [];
              weekTotalNet = this.epixWeekwisedata
                .reduce((acc, curr) => {
                  return acc + curr.net_amount;
                }, 0)
                .toFixed(3);
              this.weekTotalNet = weekTotalNet;
              // totalAdmints = this.DistributorCollection.reduce((a, b) => {
              //   b.Data.forEach((c) => {
              //     a += c.total_tickets || 0;
              //   });
              //   return a;
              // }, 0);

              this.FinalTotalCharges = [];
              this.complementaryFinalTable = [];

              if (data.PDFName) {
                this.PDFName = data.PDFName;
                this.FilePathArray.push(data.PDFName);
              }
              if (data.ExcelName) {
                this.ExcelName = data.ExcelName;
                this.FilePathArray.push(data.ExcelName);
              }
            } else {
              this.toasted.show(data.message);
            }
          })
          .catch(error => {
            console.log("ERROR:", error);
          })
          .finally(() => {
            setTimeout(() => loader.hide(), 1000);
          });
      }
    },
    removeDownloadedFile() {
      let payload = {
        fileArray: this.FilePathArray
      };
      MasterService.RemoveDownloadedFile(payload)
        .then(response => {
          const { data } = response;
        })
        .catch(error => {
          console.log("error :", error);
        });
    },
    onSelectHandler(event, type) {
      if (type == "cinema") {
        this.cinema_id = event.cine_id;
        this.selectedCinema = event;
        this.$store.dispatch("selectDropdownCinema", event);
      } else if (type == "distributor") {
        this.d_id = event.d_id;
        this.selectedMovie = [];
        this.MovieList = [];
        this.fetchDistributorMovies();
        // this.selectedDistributor = event;
      } else if (type == "movie") {
        this.movie_id = event.md_id;
        // this.selectedMovie = event;
      }
    },
    onRemoveHandler(event, type) {
      if (type == "cinema") {
        this.cinema_id = null;
        this.selectedCinema = "";
      } else if (type == "distributor") {
        this.d_id = null;
        // this.selectedDistributor = [];
      } else if (type == "movie") {
        this.movie_id = null;
        // this.selectedMovie = [];
      }
    },
    onSearchCinema: function() {
      if (this.searchCinema && this.searchCinema.length > 0) {
        this.Cinemas = this.CinemasCopy.filter(x => {
          if (
            x.cine_name.toLowerCase().includes(this.searchCinema.toLowerCase())
          ) {
            return x;
          }
        });
      } else {
        this.Cinemas = this.CinemasCopy;
      }
    },
    getCinemaList: function(cine_id) {
      this.Cinemas = [];
      MasterService.GetCinemasByRoles({ cine_id: cine_id })
        .then(response => {
          const { data } = response;
          if (data.status && data.Records.length > 0) {
            this.Cinemas = data.Records;
            this.CinemasCopy = data.Records;
            this.Cinemas.map(x => {
              if (String(cine_id) === String(x.cine_id)) {
                this.onDistributorReportFlagHandler({
                  event: null,
                  name: "isCinema",
                  value: x.cine_id,
                  cine_name: x.cine_name
                });
              }
            });
          } else {
            this.$toasted.show(data.message);
          }
        })
        .catch(this._CatchError);
    },
    ...mapActions([
      // FETCH FROM MASTER STORE
      "fetchCinemasList",
      // "fetchDistributorsList",
      // "fetchDistributorsActiveMasterMovie",
      "fetchReportDistributorsList",
      "onDistributorReportFlagHandler"
    ])
  }
};
</script>

<style>
.color-blue {
  background: #c1d7eb;
}

/* .align-last-center tr > th:last-child,
tr > td:last-child {
  text-align: center;
}

.align-first-left tr > th:first-child,
tr > td:first-child {
  text-align: left;
  padding-left: 2px;
}

.align-last-right tr > th:last-child,
tr > td:last-child {
  text-align: right;
  padding-right: 2px;
} */
</style>



// WEBPACK FOOTER //
// src/components/Pages/ReportsContainer/distributorDetailedCollectionSummaryPlayCinema.vue